"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityPicker = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  zIndex: 2,
  marginLeft: '2px',
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));
const Input = (0, _mui.styled)('input')(({
  theme
}) => ({
  width: '35px',
  height: '40px',
  paddingLeft: '50px',
  border: `2px solid ${theme.palette.grey[100]}`,
  borderRadius: '0 23px 23px 0',
  background: theme.palette.grey[100],
  color: theme.palette.text.primary,
  MozAppearance: 'textfield',
  '&::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },
  '&::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },
  '&:focus': {
    outline: 'none'
  }
}));
const Label = (0, _mui.styled)(_mui.Typography)({
  position: 'absolute',
  top: '50%',
  left: '10px',
  maxWidth: '40px',
  transform: 'translateY(-50%)'
});
const QuantityPicker = ({
  'data-testid': testId,
  maxQty,
  minQty,
  onBlur,
  quantityLabel,
  setQuantity,
  tabIndex,
  value
}) => {
  const input = (0, _react.useRef)(null);
  const handleLabelClick = (0, _react.useCallback)(() => input.current?.focus(), []);
  const handleQuantityChange = (0, _react.useCallback)(event => {
    const {
      value: inputValue
    } = event.target;
    const numericValue = Number.parseInt(inputValue, 10);
    if (numericValue > maxQty) {
      setQuantity(String(maxQty));
    } else if (numericValue < minQty) {
      setQuantity('1');
    } else {
      setQuantity(inputValue);
    }
  }, [maxQty, minQty, setQuantity]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Input, {
      ref: input,
      autoComplete: "off",
      "data-testid": testId,
      max: maxQty,
      min: minQty,
      name: "quantity",
      tabIndex: tabIndex,
      type: "number",
      value: value,
      onBlur: onBlur,
      onChange: handleQuantityChange
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Label, {
      noWrap: true,
      onClick: handleLabelClick,
      children: quantityLabel
    })]
  });
};
exports.QuantityPicker = QuantityPicker;